export const PRODUCT_KINDS = {
  QUOTA: 'QUOTA',
  FEATURE: 'FEATURE',
  PACKAGE: 'PACKAGE',
} as const;

export type ProductKind = (typeof PRODUCT_KINDS)[keyof typeof PRODUCT_KINDS];

export const PRODUCT_KEYS = {
  DATA_TRANSFER_GB: 'data_transfer_gb',
  CONTRIBUTOR: 'contributor',
  PLAY_RUN: 'play_run',
  VM_USE: 'vm_use',
  EVENT_CONTRIBUTOR: 'event_contributor',
  EVENT_REMOTE_SPEAKER_DAY: 'event_remote_speaker_day',
} as const;

export type ProductKey = (typeof PRODUCT_KEYS)[keyof typeof PRODUCT_KEYS];

export const PRODUCT_SCOPE_TYPES = {
  EVENT: 'Event',
  ORGANIZATION: 'Organization',
  FLOW: 'Flow',
} as const;

export type ProductScopeType = (typeof PRODUCT_SCOPE_TYPES)[keyof typeof PRODUCT_SCOPE_TYPES];

export type PriceHistoryEntryDto = {
  pricePerUnit: number;
  effectiveFrom: string;
  effectiveTo: string;
  changedBy?: string;
};

export type ScheduledPriceDto = {
  pricePerUnit: number;
  effectiveFrom: string;
  scheduledBy?: string;
  scheduledAt: string;
};

export type QuotaConfigDto = {
  quotaKey: string;
  quantityPerUnit: number;
};

export type FeatureConfigDto = {
  featureKey: string;
};

export type PackageConfigDto = {
  assignableTo: ProductScopeType[];
  constraints: Record<string, unknown>;
  includes: {
    quotas: Array<{ quotaKey: string; quantity: number }>;
    features: string[];
  };
};

export type ProductDto = {
  id: string;
  key: ProductKey | string;
  kind: ProductKind;
  name: string;
  description?: string;
  scopeType: ProductScopeType | string;
  unit?: string;
  pricePerUnit: number;
  priceHistory: PriceHistoryEntryDto[];
  scheduledPrice?: ScheduledPriceDto;
  validFrom?: string;
  validUntil?: string;
  isMultipleAllowed: boolean;
  quotaConfig?: QuotaConfigDto;
  featureConfig?: FeatureConfigDto;
  packageConfig?: PackageConfigDto;
  createdAt: string;
  updatedAt: string;
  deleted?: boolean;
};
